import { render, staticRenderFns } from "./modalNuevaDireccion.vue?vue&type=template&id=32e6147a&"
import script from "./modalNuevaDireccion.vue?vue&type=script&lang=js&"
export * from "./modalNuevaDireccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports